module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      'main-hide-text': _vm.hideMenuText
    }
  }, [_c('div', {
    staticClass: "sidebar-menu-con",
    style: ({
      width: _vm.hideMenuText ? '60px' : '135px',
      overflow: _vm.hideMenuText ? 'visible' : 'auto',
      background: _vm.$store.state.menuTheme === 'dark' ? '#24363f' : 'white'
    })
  }, [(!_vm.hideMenuText) ? _c('sidebar-menu', {
    attrs: {
      "menuList": _vm.menuList,
      "iconSize": 14
    }
  }) : _c('sidebar-menu-shrink', {
    attrs: {
      "icon-color": _vm.menuIconColor,
      "menuList": _vm.menuList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-header-con"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "navicon-con"
  }, [_c('Button', {
    style: ({
      transform: 'rotateZ(' + (this.hideMenuText ? '-90' : '0') + 'deg)'
    }),
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "navicon",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-middle-con"
  }, [(_vm.isShowTest) ? _c('span', [_vm._v("鸭嘴兽演示账号")]) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.user.companyName)
    }
  }), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "已实名认证",
      "placement": "right"
    }
  }, [(_vm.needCertification && _vm.companyCertificationStatus) ? _c('i', {
    staticClass: "iconfont icondunpai",
    staticStyle: {
      "color": "#19be6b"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.needCertification && !_vm.companyCertificationStatus) ? _c('span', {
    staticClass: "needCertification",
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("请完成实名认证")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "header-avator-con"
  }, [(!_vm.isShowXiniyuan) ? _c('div', {
    staticClass: "home-link",
    attrs: {
      "id": "home-link"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toIndex
    }
  }, [_vm._v("返回主页")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-dropdown-menu-con"
  }, [_c('Row', {
    staticClass: "user-dropdown-innercon",
    attrs: {
      "type": "flex",
      "justify": "end",
      "align": "middle"
    }
  }, [_c('Dropdown', {
    attrs: {
      "transfer": "",
      "trigger": "click"
    },
    on: {
      "on-click": _vm.handleClickUserDropdown
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "main-user-name"
  }, [_vm._v(_vm._s(_vm.user.userDisplayName))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "personalCenter"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "loginout",
      "divided": ""
    }
  }, [_vm._v("退出登录")])], 1)], 1), _vm._v(" "), _c('Avatar', {
    staticStyle: {
      "background": "#619fe7",
      "margin-left": "10px"
    },
    attrs: {
      "icon": "person"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tags-con"
  }, [_c('tags-page-opened', {
    style: ({
      marginLeft: _vm.hideMenuText ? '60px' : '120px'
    }),
    attrs: {
      "pageTagsList": _vm.pageTagsList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "single-page-con",
    style: ({
      left: _vm.hideMenuText ? '60px' : '120px'
    })
  }, [_c('div', {
    staticClass: "single-page"
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.cachePage
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改密码",
      "width": 500
    },
    model: {
      value: (_vm.modifyPasswordModal),
      callback: function($$v) {
        _vm.modifyPasswordModal = $$v
      },
      expression: "modifyPasswordModal"
    }
  }, [_c('Form', {
    ref: "modifyPasswordForm",
    attrs: {
      "model": _vm.modifyPasswordForm,
      "label-width": 100,
      "label-position": "right",
      "rules": _vm.passwordValidate
    }
  }, [(_vm.hasPassword) ? _c('FormItem', {
    attrs: {
      "label": "原密码",
      "prop": "oldPass",
      "error": _vm.oldPassError
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入现在使用的密码"
    },
    model: {
      value: (_vm.modifyPasswordForm.oldPass),
      callback: function($$v) {
        _vm.$set(_vm.modifyPasswordForm, "oldPass", $$v)
      },
      expression: "modifyPasswordForm.oldPass"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "新密码",
      "prop": "newPass"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "密码必须为8-16位且包含字母及数字"
    },
    model: {
      value: (_vm.modifyPasswordForm.newPass),
      callback: function($$v) {
        _vm.$set(_vm.modifyPasswordForm, "newPass", $$v)
      },
      expression: "modifyPasswordForm.newPass"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "确认新密码",
      "prop": "rePass"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入确认密码"
    },
    model: {
      value: (_vm.modifyPasswordForm.rePass),
      callback: function($$v) {
        _vm.$set(_vm.modifyPasswordForm, "rePass", $$v)
      },
      expression: "modifyPasswordForm.rePass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.cancelModifyPass
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.savePassLoading
    },
    on: {
      "click": _vm.saveModifyPass
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('certificationModal', {
    ref: "certificationModal"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-406e0596", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-406e0596"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/views/Main.vue
// module id = 1357
// module chunks = 61